<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/locales/i18n'
import { useTier } from '@/composables/useTier'
import { usePromotions } from '@/composables/usePromotions'
import UserSubscriptionBox from '@/components/Sub/UserSubscriptionBox.vue'

const { userHasRbwizardPromo } = usePromotions()
const store = useStore()
const { user_info, allSubs, purchasedSubs, nadaPurchased } = useTier('')

const subs = computed(() => {
  if (purchasedSubs.value.length > 4) {
    return purchasedSubs.value // excludes free tier
  }
  return allSubs.value
})

const canCancel = computed(() => {
  const res = user_info.value.subs || []
  return res.some(p => p.plan.game_format.toLowerCase() !== 'any' && !p.canceled)
})

const handleCancelSubClick = () => {
  store.dispatch('router_set_dialogs', 'cancel-payment-plan-dialog')
}
</script>

<template>
  <div class="user-subscription">
    <div class="card-box">
      <div class="user-subs">
        <UserSubscriptionBox
          v-for="(sub, idx) in subs"
          :key="idx"
          class="mb-4 mr-4 user-subs_item"
          :sub="sub"
          :hasFreeText="nadaPurchased"
        />
        <div
          v-if="userHasRbwizardPromo"
          class="text-medium clr-grey mt-1 mb-3"
          v-html="t('messages.subscription_rbwizard_promo')"
        />
      </div>
    </div>
    <div
      v-if="canCancel"
      class="bt-grey cancel-subscription-container"
    >
      <div
        data-tst="btn_cancel_sub"
        class="cancel-subscription-btn clr-error"
        color="transparent"
        @click="handleCancelSubClick"
      >
        {{ t('user_settings.cancel_subscription') }}
      </div>
      <div class="cancel-subscription-text">
        {{ t('user_settings.cancel_subscription_sub') }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .card-box {
    flex-direction: column;
    &_title {
      margin-bottom: 1rem;
    }
  }
}
.user-subscription {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.card-box {
  display: flex;
  border-radius: 4px;
  flex-shrink: 0;

  &_title {
    min-width: 12rem;
  }
}

.cancel-subscription-container {
  position: relative;
  margin-top: auto;
  padding: 1rem 0;
  .cancel-subscription-btn {
    font-weight: 500;
    &:hover {
      cursor: pointer;
      font-weight: 700;
    }
  }
  .cancel-subscription-text {
    font-size: 0.8rem;
    color: var(--clr-grey-2);
  }
}
.subscription-info-box {
  padding: 1rem;
  background: var(--clr-black-1-3);
  border-radius: 4px;
}
</style>
